module.exports = __webpack_public_path__ + "img/enter-the-code.0ff53dd3.svg";